import React from "react";

function Timeline() {
  return (
    <section>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        {/* Section header */}
        <div className="max-w-3xl mx-auto text-left">
          {/* <h2 className="h2 mb-4">Bringing ideas to life</h2> */}
          <p className="h2 mb-4">The path to impact</p>
          <p className="text-xl text-gray-500">
            In 2012, we began delivering real-world solutions by building "Pit
            Rho" (acquired by GM), an innovative set of AI tools and
            infrastructure used to predict and forecast optimal race strategy in
            real-time during motorsports events.
          </p>
          <br />
          <p className="text-xl text-gray-500">
            As we matured in applying data science and software engineering
            across the fields of energy, finance, healthcare, and others, we
            recognized an internal motivation was solidifying to use these core
            competencies to help solve some of the world's bigger problems.
          </p>
          <br />
          <p className="text-xl text-gray-500">
            Our involvement in what is now the{" "}
            <a
              className="font-semibold"
              href="https://cranetool.org"
              target="_blank"
              rel="noreferrer"
            >
              CRANE Tool
            </a>{" "}
            was the result of our partnership with{" "}
            <a
              className="font-semibold"
              href="https://primecoalition.org"
              target="_blank"
              rel="noreferrer"
            >
              Prime Coalition
            </a>
            , which has long been a foundational leader in advancing the field
            of catalytic capital. In 2017 Prime and NYSERDA published a seminal
            report entitled, "
            <a
              className="font-semibold"
              href="https://www.primecoalition.org/library/climate-impact-assessment-for-early-stage-ventures"
              target="_blank"
              rel="noreferrer"
            >
              Climate Impact Assessment for Early-Stage Ventures
            </a>
            ," in which they laid the foundation for everything that has been
            built today.
          </p>
          <br />
          <p className="text-xl text-gray-500">
            In 2018 we made the decision to dedicate a significant portion of
            our team to climate-focused projects. By 2020 we knew it was time to
            fully commit and in 2021 we spun out Rho Impact as a new company
            with a simple mission baked into its name:
            <em> to empower every organization to make an impact</em>.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Timeline;
